import { ProgressTrackerStatus as l } from "@nextgen-web-framework/all";
import { DateOrTime as C, DateFormats as S, TimeFormats as y } from "@nextgen-web-framework/core";
import { _, A as N } from "./commonUtils-a7a518e4.mjs";
import { _ as c } from "./postpurchaseEnums-19d3e31f.mjs";
const x = {
  xpresso: "images/xpresso.png",
  scg: "images/scg-logo.png",
  "7-11": "images/7-11-logo.svg",
  amwrider: "images/amwrider.png",
  kerry: "images/KerryTextLogo.svg",
  "flash-express": "images/flash-express.png",
  dsv: "images/dsv-logo.png",
  dhl: "images/dhl.png",
  jd: "images/jd-logo.jpg",
  SERV: "images/servientrega.png"
}, m = {
  red: "#d91734",
  white: "#fff"
}, U = (r) => {
  var n, t, d;
  let i = [];
  return i = (n = r == null ? void 0 : r.orders) == null ? void 0 : n.map((o) => {
    var g, a, e, s, u, v;
    const p = [];
    (a = (g = o.consignments) == null ? void 0 : g.entries) == null || a.forEach((O) => {
      var f, E, T, h;
      p.push(((h = (T = (E = (f = O.orderEntry) == null ? void 0 : f.product) == null ? void 0 : E.images) == null ? void 0 : T[0]) == null ? void 0 : h.url) ?? "");
    });
    const R = A(o.statusInfo);
    return {
      orderId: o.affiliateOrderNumber,
      packageLabel: (o == null ? void 0 : o.package) || "1/1",
      orderTrackingNote: o.consignmentStatus,
      productImageUrls: p ?? [],
      deliveryProgressStages: R,
      carrierImageUrl: _(x[`${o.carrier}`]),
      contactName: (e = o.deliveryAddress) == null ? void 0 : e.firstName,
      contactNumber: o.deliveryContactNumber,
      deliveryOption: (s = o.deliveryMode) == null ? void 0 : s.code,
      trackingNumber: (u = o.consignments) == null ? void 0 : u.code,
      carrierPartner: o.carrier,
      deliveryTo: (v = o == null ? void 0 : o.deliveryAddress) == null ? void 0 : v.formattedAddress
    };
  }), {
    deliveryOrders: i,
    totalPages: ((t = r == null ? void 0 : r.pagination) == null ? void 0 : t.totalPages) ?? 0,
    totalRecords: ((d = r == null ? void 0 : r.pagination) == null ? void 0 : d.totalCounts) ?? 0
  };
}, A = (r = []) => {
  var n;
  const t = [];
  if (!r.length)
    return t;
  const d = (e) => e ? `${N(e, S.MEDIUM_DATE, void 0, C.DATE_ONLY)}, ${N(
    e,
    void 0,
    y.SHORT_TIME,
    C.TIME_ONLY
  )}` : "", i = (e, s, u = {}) => ({
    title: e.stageTitle ?? "",
    status: s,
    desc: d(e.eventTime),
    ...u
  }), o = r.findIndex(
    (e) => e.status === c.RETURN
  ), g = r.filter((e) => e.status === c.SUCCESS).length === r.length;
  if (o !== -1) {
    for (let e = 0; e <= o; e++) {
      const s = r[e];
      e === o ? t.push(
        i(s, l.CURRENT, {
          textColor: m.red,
          bgColor: m.red,
          iconColor: m.white,
          borderColor: m.red,
          iconName: "close"
        })
      ) : t.push(i(s, l.COMPLETED_GRAY));
    }
    return t;
  }
  if (g)
    return r.forEach(
      (e, s) => t.push(
        i(
          e,
          s === r.length - 1 ? l.COMPLETED : l.COMPLETED_GRAY
        )
      )
    ), t;
  const a = (r == null ? void 0 : r.length) - 1 - ((n = [...r].reverse()) == null ? void 0 : n.findIndex((e) => e.status === c.SUCCESS));
  for (let e = 0; e <= a; e++) {
    const s = r[e];
    t.push(
      i(s, e === a ? l.CURRENT : l.COMPLETED_GRAY)
    );
  }
  return t;
};
export {
  A as U,
  U as p,
  x as s
};
//# sourceMappingURL=deliveryTrackingTransformer-b77e06af.mjs.map
